<template>
    <div :class="'card card-inverse differency-card card-' + color">
        <div class="card-header" style="word-wrap: normal; white-space: nowrap;">
            <i :class="' pull-left fa fa-' + icon" style="margin-top: 5px;"></i>
            <span class="average_title" @click="idPopupAllCountry" v-if="title === 'Средний чек'">{{title}}</span>
            <span v-else>{{ title }}</span>
            <span :class="($root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'"  style="word-wrap: normal; white-space: nowrap;">
            <span :class="($root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'" v-if="!calculate">{{ average }}{{ symbol }}</span>
            <span :class="($root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'" v-if="calculate">{{ average }}{{ symbol }}
                <span :class="($root.MobileDetect.mobile() ? ' pull-left ' : 'pull-right ') + 'tag'">
                    <i :style="diffStyle(average)">{{ diffSymbol(average) }}</i></span>
            </span>
          </span>
        </div>

        <div class="card-block" style="word-wrap: normal; white-space: nowrap; display: block;" v-if="isLeads">
            <div class="col-6" style="margin: 0 6%;">
                <table class="table d-none d-sm-block d-md-block d-lg-block" style="margin-bottom: 0">
                    <thead>
                    <tr>
                        <th style="font-size: 10px; border: none"></th>
                        <th style="font-size: 10px; border: none"></th>
                        <th @click="sort('limit')" class="th-action" style="font-size: 10px;border: none; text-align: center">Лимит<br/> КЦ</th>
                        <th @click="sort('weekAverage')" class="th-action" style="font-size: 10px;border: none; text-align: center">Трафик <br/>за неделю</th>
                        <th @click="sort('difference')" class="th-action" style="font-size: 10px;border: none; vertical-align: middle">Разница</th>
                    </tr>
                    </thead>
                </table>
            </div>
            <div class="row differency-table" style="word-wrap: normal; white-space: nowrap; border-bottom: 1px solid rgba(0, 0, 0, 0.1);" v-for="line in preparedData">
                <div class="col-6 backed" style="word-wrap: normal; white-space: nowrap; display: block; border-bottom: none;">
                    <i :class="'flag-' + line.country_code" class="flag" ></i>
                    <div
                        class="country-name" style="word-wrap: normal; white-space: nowrap; float: left;">{{ $t('country.' + line.country_id) }}</div>
                    <div class="leadsLimit d-none d-sm-block d-md-block d-lg-block" style="position: absolute; top:5px;left: 130px;"><small>{{line.limit}}</small></div>
                    <div class="avarege d-none d-sm-block d-md-block d-lg-block" style="position: absolute; top:5px;left: 200px;"><small>{{line.weekAverage}}</small></div>
                    <div class="different d-none d-sm-block d-md-block d-lg-block" style="position: absolute; top:5px;left: 272px;"><small>{{line.weekAverage - line.limit}}</small></div>
                </div>
                <div class="col-3">
                    <div :class="line.average ? 'i-spaced' : null" class="pull-right gist" style="word-wrap: normal; white-space: nowrap; display: block; max-width: 70px;line-height: 2">
                        <div style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                            <small>{{ line.diff }}{{ symbol }}
                                <i :style="diffStyle(line.diff)">{{ diffSymbol(line.diff)}}</i>
                            </small>
                        </div>
                        <div style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                            <i :style="diffStyle(line.total - line.average)" v-if="line.average">
                                <small>{{ line.total - line.average}}</small>
                            </i>
                        </div>
                    </div>
                </div>
                <div :style="renderGist(line)" class="col-3 gisted nobr" style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                    <span class="pull-right gist total"><small><strong>{{ line.total }}{{ symbol }}</strong></small></span>
                </div>
            </div>
        </div>
        <div class="card-block" style="word-wrap: normal; white-space: nowrap; display: block;" v-else>
            <div class="row differency-table" v-for="line in preparedData" style="word-wrap: normal; white-space: nowrap;">
                <div class="col-9 backed" style="word-wrap: normal; white-space: nowrap; display: block;" >
                    <i class="flag" :class="'flag-' + line.country_code"></i>
                    <div class="country-name" @click="isPopup(line.country_id)" style="word-wrap: normal; white-space: nowrap; float: left; cursor:pointer;">{{ $t('country.' + line.country_id, )}}</div>
                    <div class="pull-right gist" :class="line.average ? 'i-spaced' : null" style="word-wrap: normal; white-space: nowrap; display: block;">
                        <div style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                            <small>{{ line.diff }}{{ symbol }} <i :style="diffStyle(line.diff)">{{ diffSymbol(line.diff) }}</i></small>
                        </div>
                        <div style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                            <i v-if="line.average" :style="diffStyle(line.total - line.average)">
                                <small>{{ line.total - line.average}}</small>
                            </i>
                        </div>
                    </div>
                </div>
                <div :style="renderGist(line)" class="col-3 gisted nobr bl" style="word-wrap: normal; white-space: nowrap; overflow:hidden; display: block;">
                    <span class="pull-right gist total"><small><strong>{{ line.total }}{{ symbol }}</strong></small></span>
                </div>
            </div>

        </div>

        <modal v-model="chartModalDif" large effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title" style="color: #000; width: 100%; text-align: center">{{titleAverage}} </h4>
            </div>
            <div class="card-block">
                <div id="dash-chart-traffic-dif"></div>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-info" @click="chartModalDif = false"> {{ $t('verbs.close') }}</button>
            </div>
        </modal>
    </div>
</template>
<script>
  import { map, orderBy, find, cloneDeep } from 'lodash'
  import Storage from '../api/Storage'
  import CountryColor from '../assets/CountryColor'
  import { modal } from 'vue-strap'
  import API from '../api/API'
  import StatisticTable from '../components/StatisticTable.vue'
  import Highcharts from 'highcharts'
  import Exporting from 'highcharts/modules/exporting'

Exporting(Highcharts)
let chartOptionsDif = {
    isHidden: false,
    title: {
      text: null
    },
    subtitle: {
      text: null
    },
    yAxis: [{ // --- Primary yAxis
      title: {
        text: `Средний чек $`
      },
      min: 0,
      tickInterval: 10
    }],
    xAxis: {
      categories: []
    },
    credits: {
      enabled: false
    },
    legend: {
      enabled: false
    },
    exporting: {
      enabled: false
    },
    series: [{
      data: []
    }],
    tooltip: {
      formatter: function () {
        return '$ ' + this.y
      }
    }
  }
export default {
    props: {
      symbol: {
        type: String,
        default: null,
        required: false
      },
      isLeads: Boolean,
      color: {
        type: String,
        default: 'info',
        required: false
      },
      icon: {
        type: String,
        default: 'line-chart',
        required: false
      },
      title: {
        type: String,
        required: true
      },
      tableData: {
        type: Object,
        required: true
      },
      calculate: {
        type: Boolean,
        default: false
      },
      withAverage: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        chartOptionsDif,
        average: 0,
        Storage: Storage,
        find: find,
        order: 'asc',
        tableDataBySort: null,
        max: 0,
        tableDataWithDifference: [],
        chartModalDif: false,
        titleAverage: '',
        chartSeries: [],
        countryCurrencySymbol: ''
      }
    },
    computed: {
      preparedData () {
        let data
        if (!this.tableDataBySort) {
          data = cloneDeep(this.tableData)
        } else {
          data = cloneDeep(this.tableDataBySort)
        }
        let total = 0
        let count = 0
        let diff = 0.00001
        map(data, (d, i) => {
          const country = find(Storage.countries, {id: parseInt(d.country_id, 10)})
          data[i].country_code = country.code.toLowerCase()
          if (this.isLeads) {
            data[i].difference = data[i].weekAverage - data[i].limit
          }
          if (d.total > 0) {
            if (this.symbol === '$') {
              data[i].total = parseFloat(parseFloat(parseFloat(d.total)) / parseFloat(country.rate)).toFixed(0)
            } else {
              data[i].total = parseInt(d.total, 10)
            }

            if (this.symbol !== null) {
              data[i].diff = parseFloat(d.diff).toFixed(1)
              diff = parseFloat(diff) + parseFloat(d.diff)
            } else {
              data[i].diff = parseFloat(d.diff).toFixed(0)
              diff = parseInt(diff, 10) + parseInt(d.diff, 10)
            }

            this.max = data[i].total > this.max ? data[i].total : this.max
            total += parseFloat(data[i].total)
            count++
          }
        })
        if (!this.calculate) {
          this.average = parseFloat(total / count).toFixed(0)
        } else {
          if (!this.withAverage) {
            this.average = diff
          } else {
            this.average = parseFloat(parseFloat(diff) / parseFloat(count)).toFixed(1)
          }
        }
        if (!this.tableDataBySort) {
          return orderBy(data, [(e) => {
            return parseInt(e.total, 10)
          }], ['desc'])
        } else {
          return data
        }
      }
    },
    methods: {
      diffStyle (diff) {
        return diff > 0 ? 'color: green' : 'color: red'
      },
      diffSymbol (diff) {
        return diff === 0 ? `` : diff > 0 ? `▲` : `▼`
      },
      renderGist (line) {
        if (this.symbol !== null) {
          return `background: linear-gradient(to right, ${CountryColor[line.country_id]} ${line.total}%, transparent 0%)`
        } else {
          return `background: linear-gradient(to right, ${CountryColor[line.country_id]} ${parseFloat(line.total / this.max * 100).toFixed(0)}%, transparent 0%)`
        }
      },
      sort (field) {
        this.order = (this.order === 'asc' ? 'desc' : 'asc')
        this.tableDataBySort = orderBy(this.tableData, [function (item) {
          if (field === 'difference') {
            return item[field]
          } else {
            return !item[field].ocb ? item[field] : item[field].ocb(item[field])
          }
        }], [this.order])
      },
      isPopup (id) {
        const country = find(Storage.countries, {id: parseInt(id, 10)})
        this.countryCurrencySymbol = country.currency_symbol
        this.titleAverage = `Средний чек: ($)`
        const chartSeries = new Promise(function (resolve, reject) {
          API.getAveragesGraphic(id).then(response => {
            resolve(response.body)
            return response.body
          }).catch(err => console.log(err))
        })
        chartSeries.then(response => {
          let array = []
          for (let i in response) {
            array.push(parseFloat(response[i].toFixed(2)))
            chartOptionsDif.xAxis.categories.push(i)
            chartOptionsDif.series[0] = {
              data: [...array]
            }
          }
          this.chartModalDif = true
          Highcharts.chart('dash-chart-traffic-dif', chartOptionsDif)
          this.chart = Highcharts.chart('dash-chart-traffic-dif', chartOptionsDif)
        })
      },
      idPopupAllCountry () {
        this.chartSeries = []
        this.titleAverage = 'Средний чек по всем странам ($)'
        const chartSeries = new Promise(function (resolve) {
          API.getAveragesGraphicAllCountry().then(response => {
            resolve(response.body)
            return response.body
          })
        })
        chartSeries.then(response => {
          let array = []
          for (let i in response) {
            array.push(parseFloat(response[i].toFixed(2)))
            chartOptionsDif.xAxis.categories.push(i)
            chartOptionsDif.series[0] = {
              data: [...array]
            }
          }
          this.chartModalDif = true
          Highcharts.chart('dash-chart-traffic-dif', chartOptionsDif)
          this.chart = Highcharts.chart('dash-chart-traffic-dif', chartOptionsDif)
        })
      }
    },
    name: 'DifferencyTable',
    components: {
      modal,
      StatisticTable
    }
  }
</script>
<style>
    .nobr {
        white-space:nowrap;
    }
    .average_title {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// DifferencyTable.vue?b4b4884e